"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _SvgIcon = require("../SvgIcon");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const BACKGROUND_SIZES = {
  S: 30,
  M: 40,
  L: 50
};
const StyledBackgroundSvgIcon = (0, _styledComponents.default)(_SvgIcon.SvgIcon).withConfig({
  displayName: "StyledBackgroundSvgIcon",
  componentId: "sc-1nojtwk-0"
})(["&&{", "}"], _ref => {
  let {
    $size
  } = _ref;
  const negativeMargin = `-${(BACKGROUND_SIZES[$size] - _constants.SIZES[$size].backgroundSize) / 2}px`;
  return `
        margin: ${negativeMargin};
      `;
});
const WarningIcon = _ref2 => {
  let {
    color,
    background,
    size = 'M',
    ...props
  } = _ref2;
  if (background) {
    return /*#__PURE__*/React.createElement(StyledBackgroundSvgIcon, _extends({}, props, {
      viewBox: "0 0 40 40",
      width: BACKGROUND_SIZES[size],
      height: BACKGROUND_SIZES[size],
      $size: size
    }), /*#__PURE__*/React.createElement("path", {
      fill: background,
      d: "M.425 34.506L18.267 3.282c.64-1.12 2.255-1.12 2.894 0l17.843 31.224A1.667 1.667 0 0137.557 37H1.872a1.667 1.667 0 01-1.447-2.494z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: color,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 27a2 2 0 100 4 2 2 0 000-4zm-1-3a1 1 0 102 0v-9a1 1 0 10-2 0v9z"
    }));
  }
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
    size: size,
    color: color,
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16a2 2 0 100 4 2 2 0 000-4zm-1-3a1 1 0 102 0V4a1 1 0 10-2 0v9z"
  }));
};
exports.WarningIcon = WarningIcon;